import { React, useState, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { Container, Row, Popover, OverlayTrigger, Modal } from "react-bootstrap";
import "./Header.css";
import "../responsive.css";
import api from "../../seller-apis/api";
import Button from "./Button";
import { fetchAllNotifications, filterOrdersfilter, pendingFromSellerProducts, fetchunansQA, pendingFromSellerProductsWithourRejected, fetchOpportunityData } from "../../seller-apis/apidataField";
import { useDispatch, useSelector } from "react-redux";
import { defaultAction } from "../../Actions/Default";
import { Actions } from "../../Actions/Actions";
import PopupNotification from "./PopupNotification";
import { useLocation } from "react-router-dom";
import { pagesJson } from "../../utilities/pagesjson";
import ActionRequiredValidationModal from "./ActionRequiredValidationModal";
import WalletDropDown from "./WalletDropdown";
import moment from "moment";
import VendorBlockedStausModal from "./VendorBlockedStausModal";
import FeatureRequestModal from "./FeatureRequestModal";
import { useAlert } from "react-alert";
import BulkStockPopup from "../common/BulkStockPopup";
import { useNotification } from "./OrderLost/NotificationContext";
import { unregisterDeviceToken } from "../../services/push.service";
import {
  getRemainingGrabOrderNotificationCount,
} from "../../utilities/grabOrderNotificationStorage";
const currentUrl = window.location.pathname;

var dateFromWeb = moment().subtract(15, 'days').format('YYYY-MM-DD');
var dateToWeb = moment().format('YYYY-MM-DD');
var globalFilter = {
  pageNo: 1,
  size: 5,
  filters: {
    type: { $in: ["PRC_CHANGED"] },
    "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
    "to-createdAt": dateToWeb + 'T23:59:59.000Z'
  },
};
var QuesFilterData = {
  pageNo: "1",
  size: 1,
  type: "NEW"
};

// Brand filter for fetching first active brand
var brandGlobalFilter = {
  "pageNo": 1,
  "size": 1
};


// Global flag to track if Header API calls have been made in this session
var headerApiCallsMade = false;

function Header() {
  const { sellerPic, sellerMeData, sellerMeMessage, sellerMeLoaded } = useSelector((state) => state.vendorDetailsReducer);
  const dispatch = useDispatch();
  const history = useHistory();
  const { isProfileOk } = useSelector(state => state.profileReducer);
    const notificationCountState = useSelector((state) => state.ActionReducer.notificationCount);

  const { addOrderLostNotification,addGrabOrderNotification } = useNotification()

  // Seller details
  const [sellerDetail, setsellerDetails] = useState("");
  const [isVerifiedSeller, setisVerifiedSeller] = useState(true);
  const [showActionReqPopup, setShowActionReqPopup] = useState(false);
  const [showVendorBlockedPopup, setShowVendorBlockedPopup] = useState(false);
  const [showNotifications, setShowNotifications] = useState("none");
  const [notificationsList, setNotificationsList] = useState([]);
  const [notificationCntn, setNotificationCntn] = useState(0);
  const [specificInfo, setSpecificInfo] = useState(null);
  const [supportMsgCount, setSupportMsgCount] = useState(0);
  const [pageNotification, setPageNotification] = useState(null);
  const [pageNotifications, setPageNotifications] = useState([]);
  const [pageHeader, setPageHeader] = useState(null);
  const [walletAmt, setWalletAmt] = useState(0);

  // New state for brand store
  const [firstActiveBrand, setFirstActiveBrand] = useState(null);
  const [shareModal, setShareModal] = useState(false);
  const [isCopied, setIsCopied] = useState(false);



  // sl-707
  const [feaMissModalShow, setFeaMissModalShow] = useState(false)
  const [featureMissingAlert, setFeatureMissingAlert] = useState(true)
  const actionReducer = useSelector(
  (state) => state.ActionReducer
);
const stateData = {
  ActionReducer: actionReducer,
};

  const location = useLocation();
  const alert = useAlert()

  // Function to fetch first active brand
  const fetchFirstActiveBrand = async () => {
    try {
      const res = await api.TradeMark.activeTradeMark(brandGlobalFilter);
      const brands = res?.data?.data || [];

      // Find first active and subscribed brand
      const activeBrand = brands.find(brand =>
        brand?.status === "ACTIVE" && brand?.subscription_status === "SUBSCRIBED"
      );

      if (activeBrand) {
        setFirstActiveBrand(activeBrand);
      }
    } catch (err) {
      console.log("Error fetching brand:", err);
    }
  };

  // Function to handle share store click - opens modal instead of direct redirect
  const handleShareStore = (brand) => {
    setShareModal(true);
    setIsCopied(false); // Reset copy state when opening modal
  };

  // Copy to clipboard function
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      // Reset to "Copy" after 2 seconds
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy text: ', error);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      } catch (fallbackError) {
        console.error('Fallback copy failed: ', fallbackError);
      }
      document.body.removeChild(textArea);
    }
  };

  // Share on WhatsApp function
  const shareOnWhatsApp = (brand, url) => {
    const message = `Checkout *${brand?.brandName || brand?.manufacturerName}* Brandstore on Toolsvilla: \n🛒 Explore now: ${url}`;
    //const whatsappUrl = `https://api.whatsapp.com/send/?text=${encodeURI(message)}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };


  useEffect(() => {
    if (!sellerMeLoaded || !sellerMeData) return;
    setsellerDetails(sellerMeData);
    setWalletAmt(sellerMeData?.wallet?.currentBal);
    // Same as old Header `me` callback: ActionReducer counts for modals / layout
    Actions.upadteWalletAmount(dispatch, sellerMeData?.wallet || []);
    Actions.updateBlockedVendorStatus(dispatch, sellerMeData?.tmpStatus);
    if (sellerMeMessage === "Seller Not Activated") {
      setisVerifiedSeller(false);
    } else {
      setisVerifiedSeller(true);
    }
  }, [sellerMeLoaded, sellerMeData, sellerMeMessage, dispatch]);

  useEffect(() => {

    // Check if API calls have been made in this session
    if (headerApiCallsMade) {
      console.log('⏭️ Header: Skipping API calls - already made in this session');
      return;
    }

    headerApiCallsMade = true;
    defaultAction(dispatch, localStorage.getItem("image"));

    // Fetch first active brand
    fetchFirstActiveBrand();

    // Fetch grab order notification
    // SL-1130
    fetchGrabOrderNotification();

    const countData = {
      pageNo: 1,
      size: 1,
      filters: {
        type: { $in: ["PRC_CHANGED"] },
        opened: false,
        "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
        "to-createdAt": dateToWeb + 'T23:59:59.000Z'
      },
    };

    // SL-1124
    api.notify
  .fetchNotifications(fetchAllNotifications(countData))
  .then((res) => {
    Actions.updateNotificationCount(dispatch, res.totalRecords);  // NEW - stores in Redux
    setNotificationCntn(res.totalRecords);  // Keep this if you still need local state
  })
  .catch((err) => console.log(err));

    api.specificInformation.specificInformationList().then(res => {
      setPageNotifications(res.data.records);
      let splitedlocation = location.pathname.split('/');
      let pageName = splitedlocation[splitedlocation.length - 1];
      res.data.records.forEach(element => {
        if (element?.pages && element?.pages.length > 0) {
          if (element?.pages.indexOf(pageName) != -1) {
            setPageNotification(element.desc);
          }
          if (element.pages.indexOf('all') != -1) {
            setSpecificInfo(element);
          }
        }
      })
    });

    // setInterval(() => {
    //   getSupportMsgNotificationCount();
    // }, 900000);
    getSupportMsgNotificationCount();

    api.order.orders(filterOrdersfilter({
      "pageNo": "1",
      "size": 1
    }, ["ASSIGN"])).then((res) => {
      Actions.OrderCountAction(dispatch, { newOrders: res.totalRecords });
    }).catch(err => {
      // console.log(err)
    })

    let pARGlobalFilter = {
      pageNo: 1,
      size:1
    };
    api.product
      .sellerProductsRetrieveAll(pendingFromSellerProductsWithourRejected(pARGlobalFilter))
      .then((res) => {
        Actions.updateProductActReqCount(dispatch, res.totalRecords)
      })
      .catch((err) => {
        console.log(err);
      });

      // SL-1172

    // api.QandA.QuestionAnswerCount({}).then((res) => {
    //   console.log(res?.data.data.records);
    //   res?.data.data.records.forEach(element => {
    //     element.questionType == 'NEW' && Actions.upadteQuesCount(dispatch, element.count);
    //   });
    // });

    // SL-1172
    // var leadFilterData = {
    //   pageNo: 1,
    //   size: 1,
    //   "vendorFilter": {
    //     "status": "LOCKED"
    //   },
    // };
    // api.customerLeads.getLeads(leadFilterData).then((res) => {
    //   Actions.leadCount(dispatch, res.data.totalRecords);
    // });

    var leadFilterData2 = {
      pageNo: 1,
      size: 1,
    };
    api.customerLeads.getLeads(leadFilterData2).then((res) => {
      Actions.totalLeadCount(dispatch, res.data.totalRecords);
    });

    // api.notices.getActiveNotices(
    //   localStorage.getItem("vendorId"),
    //   1,
    //   0,
    // ).then((res) => {
    //   Actions.PendingNoticeCountAction(dispatch, res?.data?.stats?.pending);
    //   //Actions.PendingNoticeCountAction(dispatch, 5); // Test with hardcoded value
    // });

    api.notices.getActiveNotices(
      localStorage.getItem("vendorId"),
      1,
      0,
    ).then((res) => {
      Actions.PendingNoticeCountAction(dispatch, res?.data?.stats?.pending);
    }).catch((err) => {
      console.error("API Error:", err);
    });

  }, [])

  useEffect(() => {
    setPageNotification(null);
    let splitedlocation = location.pathname.split('/');
    let pageName = splitedlocation[splitedlocation.length - 1];
    pageNotifications.forEach(element => {
      if (element?.pages && element?.pages.length > 0) {
        if (element.pages.indexOf(pageName) != -1) {
          setPageNotification(element.desc);
        }
      }
    })
    setPageHeader(pagesJson[pageName]);
  }, [location.pathname]);

  useEffect(() => {
    setShowActionReqPopup(false);
    setShowVendorBlockedPopup(false);
    if (stateData.ActionReducer.pActionRequiredCount > 0 && location.pathname != '/my-inventory/new_product_request/action_req') {
      setShowActionReqPopup(true);
    }
    if (stateData.ActionReducer.vendorBlockedStatus > 0 && location.pathname != '/support' && location.pathname != '/home') {
      setShowVendorBlockedPopup(true);
    }
  }, [location.pathname, stateData.ActionReducer.pActionRequiredCount, stateData.ActionReducer?.vendorBlockedStatus])

  useEffect(() => {
    setSupportMsgCount(stateData.ActionReducer.sellerCount);
  }, [stateData.ActionReducer.sellerCount]);

  useEffect(() => {
    setWalletAmt(stateData.ActionReducer.WalletAmount);
  }, [stateData.ActionReducer.WalletAmount]);

  const getSupportMsgNotificationCount = () => {
    let fromDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
    let toDate = moment().format('YYYY-MM-DD');
    let param = {
      "pageNo": 1, "size": 1, "filter": {
        $and: [
          { "adminMsgInfo.vendorViewed": false },
          { "adminMsgInfo.latestMessage": { $exists: true } },
        ],
        "from-createdAt": fromDate + 'T00:00:00.000Z',
        "to-createdAt": toDate + 'T23:59:59.000Z'
      }, "sortFilter": { "createdAt": -1 }
    }
    api.supportTicket.getSupportTicket(param).then((ticket) => {
      Actions.updateSellerCount(dispatch, ticket.totalRecords);
    });
  }

  // SL-973

  const fetchLostOrders = (page, size) => {
    api.order.getVendorLostOrders(page, size,'notification').then((res) => {
      console.log(res);
      const records = res?.data || [];
      records.forEach((lostOrder) => {
        let foundCmb;
        let combinationArray = lostOrder?.product?.productId?.combination;
        if(combinationArray && combinationArray?.length>0){
          foundCmb = combinationArray.find((cmb) => cmb?.SKU === lostOrder?.product?.SKU)
        }
        addOrderLostNotification({
          productName:lostOrder?.product?.productName || 'N/A',
          winningVendor:lostOrder?.winningVendor || '',
          winningPrice:lostOrder?.selectedVendor?.purchasePrice || 'N/A',
          vendorPrice:lostOrder?.lostVendorDetails?.purchasePrice || 'N/A',
          lowestPrice:lostOrder?.lowestPrice || 'N/A',
          image:lostOrder?.product?.productImage || null,
          product_id:lostOrder?.product?.productId?._id || null,
          _id:lostOrder?._id,
          SKU:lostOrder?.product?.SKU,
          foundCombination:foundCmb,
          attributes:lostOrder?.product?.productId?.combination?.[0]
      });
      });
    }).catch(err => {
      console.log(err);
    });
  }

  const fetchGrabOrderNotification = () => {
    const remainingNotificationCount = getRemainingGrabOrderNotificationCount();
    if (remainingNotificationCount <= 0) {
      return;
    }
    let grabOrderNotificationFilterData = {
      pageNo: 1,
      size: remainingNotificationCount,
      filters: {
        "availableForNotification": true,
        "status": "pending",
        "orderType": 'grab_order',
        "isRead": false
      },
      sortFilter: { "createdAt": -1 },
    };

    api.Opportunity.fetchOpportunity(fetchOpportunityData(grabOrderNotificationFilterData)).then(res => {
      handleGrabNotification(res.data);
      // SL-1158
      if(res?.data?.length < remainingNotificationCount){
          fetchLostOrders(1, remainingNotificationCount - (res?.data?.length ||0));
      }
    });
  }

    const handleGrabNotification = (grabOrders) => {
    for (let orderData of grabOrders) {
      addGrabOrderNotification({
        productName: orderData?.productName,
        winningVendor: orderData?.vendorName,
        winningPrice: orderData?.otherSellerPrice,
        vendorPrice: orderData?.purchasePrice,
        image: orderData?.image || '',
        product_id: orderData?.productId,
        _id: orderData?._id || '',
        SKU: orderData?.SKU || '',
        urlKey: orderData?.urlKey,
        attributeValue: orderData?.attributeValue,
        attributes: orderData?.attributes,
        lowestPrice: orderData?.lowestPrice,
        expTransferPriceFrom: orderData?.expTransferPriceFrom != null
          ? Math.ceil(parseFloat(orderData.expTransferPriceFrom))
          : null,
        expTransferPriceTo: orderData?.expTransferPriceTo != null
          ? Math.ceil(parseFloat(orderData.expTransferPriceTo))
          : null,
        order: orderData?.order,
        from: "notification"
      })
    }
  }

  // Show notifications
  function openNotificationPop() {
    setShowNotifications("block");
  }
  function closeNotificationPop() {
    setShowNotifications("none");
  }

  async function logout() {
    try {
      await unregisterDeviceToken()
    }
    catch (err) {
      console.warn("Error during unregisterDeviceToken on logout:", err);
    } finally {
      localStorage.clear();
      headerApiCallsMade = false;
      window.location.assign("/");
    }
  }

  useEffect(() => {
    toggleSidebar(false);
  }, [location])

  function toggleSidebar(data) {
    Actions.toggleSideBar(dispatch, data);
  }

  // sl-707
  const styles = {
    text: {
      featureMissing: {

      }
    },
    container: {
      featureMissing: {
        background: "#c5d6d6",
        padding: "1px",
        fontWeight: "800"
      },
      close: {
        textAlign: "right",
      }
    },
    button: {
      subFeaReq: {
        marginLeft: "10px",
        padding: "1px 9px",
        fontWeight: "800",
        fontSize: "10px"
      }
    },
    close: {
      marginRight: "10px",
      fontSize: "26px",
      fontWeight: "800",
      cursor: "pointer"
    }
  }

  const feaMissHandleClose = () => {
    setFeaMissModalShow(false)
  }

  const feaMissHandleConfirm = (msg, req_type) => {
    setFeaMissModalShow(false)
    api.Support.add({
      "desc": msg,
      "req_type": req_type
    }).then((res) => {
      if (res?.data?.message === "Success") {
        alert.success("Request submitted successfully.")
        feaMissHandleClose()
      }
    }).catch(err => {
      alert.error("Error")
      feaMissHandleClose()
    })
  }

  return (
    <div>
      <div className="main-header">
        {
          featureMissingAlert &&
          <div className="row" style={styles.container.featureMissing}>
            <div className="col-9 text-center">
              Are we missing a feature you need?
              <button className="animated-btn-1" style={styles.button.subFeaReq} onClick={() => setFeaMissModalShow(true)}>Submit a feature request</button>
            </div>
            <div className="col-2 text-left">
              {/* Add Share Brand Store Button after VideoTutModal */}
              {isVerifiedSeller && firstActiveBrand && (
                <div className="header_vid_tuts my-auto" style={{ marginRight: '10px' }}>

                  <button
                    onClick={() => handleShareStore(firstActiveBrand)}
                    style={{
                      backgroundColor: '#28a745',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '0.375rem 0.60rem',
                      fontSize: '0.700rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.25rem',
                      width: 'fit-content',
                      fontWeight: '600'
                    }}
                    className="btn btn-success btn-sm"
                    title={`Share ${firstActiveBrand.name || 'Brand'} Store`}
                  >
                    <i className="bi bi-share"></i>
                    Share your Brandstore
                  </button>
                </div>
              )}
            </div>
            <div className="col-1" style={styles.container.close}>
              <i className="bi bi-x" style={styles.close} onClick={() => setFeatureMissingAlert(false)}></i>
            </div>
          </div>
        }
        <div className="header_row">
          <div className="col-12 header_row_2">
            <div className="header-inner">

              <div className="header-left">
                {specificInfo?.desc && isVerifiedSeller && (
                  <div className="special-information">
                    <div className="tag-image">
                      <img src="/new-button.gif" />
                    </div>
                    <div className="inner-container">
                      <div
                        className="message"
                        dangerouslySetInnerHTML={{ __html: specificInfo?.desc }}
                      ></div>
                      <a href={specificInfo?.url} target="_blank">
                        {specificInfo?.url_label}
                      </a>
                    </div>
                  </div>
                )}
              </div>
              <div className="header-right">
                <div></div>
                <div className="header-icon">
                  <div className="d-block d-lg-none" onClick={() => toggleSidebar(true)}>
                    <i class="fa fa-bars mobile-menu fs-30" aria-hidden="true"></i>
                  </div>
                  <img src="/seller-logo.webp" className="d-block d-lg-none" style={{ width: "54px" }} />
                  {/* I1-3133 remove subscripton active button div only for design*/}
                  <div></div> 
                  {/* <div>{stateData.ActionReducer.TotalLeadCount ? <WalletDropDown walletAmt={walletAmt} /> : ""}</div> */}
                  
                  {/* SL-1124 */}
                  {isVerifiedSeller && <div className="header_vid_tuts support my-auto">

                    <div className="badge-outer">
                      <div className="support-badge">{notificationCountState}</div>
                    </div>
                    <a href="#" onClick={(e) => openNotificationPop()}>
                      <img
                        className="vid_tuts_logo"
                        src="/notificationIcon.webp"
                        alt="videoTuts"
                        role="button"
                      />
                    </a>
                  </div>}

                  {isVerifiedSeller && <div className="header_vid_tuts support my-auto">
                    <div className="badge-outer"><div className="support-badge">
                      {supportMsgCount || 0}
                    </div></div>
                    <NavLink exact to="/support?flag=header">
                      <img
                        className="vid_tuts_logo"
                        src="/conversation.webp"
                        alt="videoTuts"
                        role="button"
                      />
                    </NavLink>
                  </div>}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Detail popup */}
      <div
        id="notificationDetails"
        className="overlay"
        style={{
          display: showNotifications,
          opacity: showNotifications ? 1 : 0,
          visibility: showNotifications ? "visible" : "hidden",
        }}
      >
        {
          showNotifications === "block" &&   <PopupNotification
          data={notificationsList}
          popupVisibility={closeNotificationPop}
        />
        }

        <FeatureRequestModal
          show={feaMissModalShow}
          handleClose={feaMissHandleClose}
          handleConfirm={feaMissHandleConfirm}
        />
      </div>

      {/* Share Brand Store Modal */}
      <Modal show={shareModal} onHide={() => setShareModal(false)} size="md" className='brand-share-modal'>
        <Modal.Header className='border-bottom-0 justify-content-center' style={{ position: 'relative', paddingBottom: '0.5rem' }}>
          <Modal.Title style={{ fontSize: '1.125rem', fontWeight: '600', color: '#333' }}>
            Share {firstActiveBrand?.brandName || firstActiveBrand?.manufacturerName || 'Brand'} Store
          </Modal.Title>
          <button
            onClick={() => setShareModal(false)}
            style={{
              position: 'absolute',
              right: '1rem',
              top: '1rem',
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              color: '#6c757d',
              padding: '0',
              lineHeight: '1'
            }}
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: 'white', padding: '1.0rem' }}>
          <div style={{ maxWidth: '400px', margin: '0 auto' }}>

            <div style={{ marginBottom: '1rem' }}>
              <h6 style={{
                textAlign: 'left',
                marginBottom: '0.5rem',
                color: '#333',
                fontWeight: '600',
                fontSize: '0.875rem'
              }}>
                Brand Store URL
              </h6>
              <div style={{ display: 'flex', alignItems: 'stretch', gap: '0.5rem' }}>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '4px',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  display: 'flex',
                  alignItems: 'center',
                  flex: 1,
                  minHeight: '38px'
                }}>
                  <span style={{
                    fontSize: '0.875rem',
                    color: '#495057',
                    wordBreak: 'break-all',
                    fontFamily: 'monospace'
                  }}>
                    {firstActiveBrand?.url}
                  </span>
                </div>
                <button
                  style={{
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '0.375rem 0.75rem',
                    fontSize: '0.875rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.25rem',
                    fontWeight: '500',
                    minWidth: '70px',
                    justifyContent: 'center',
                    height: '38px'
                  }}
                  onClick={() => copyToClipboard(firstActiveBrand?.url)}
                >
                  <i className={isCopied ? "bi bi-check" : "bi bi-files"}></i>
                  {isCopied ? 'Copied' : 'Copy'}
                </button>
              </div>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <h6 style={{
                textAlign: 'left',
                marginBottom: '0.5rem',
                color: '#333',
                fontWeight: '600',
                fontSize: '0.875rem'
              }}>
                Share on WhatsApp
              </h6>
              <button
                style={{
                  backgroundColor: '#25d366',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '0.75rem 1rem',
                  fontSize: '0.875rem',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  width: '100%',
                  fontWeight: '500'
                }}
                onClick={() => shareOnWhatsApp(firstActiveBrand, firstActiveBrand?.url)}
              >
                <i className="bi bi-whatsapp"></i>
                Share on WhatsApp
              </button>
              <p style={{
                fontSize: '0.75rem',
                color: '#6c757d',
                margin: '0.5rem 0 0',
                textAlign: 'center'
              }}>
                Opens WhatsApp with your brand store link ready to share
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>

        {pageNotification ?       <div className="header-bottom"><div class="alert-msg"
          dangerouslySetInnerHTML={{
            __html: pageNotification,
          }}
        >

        </div>      </div> : ""}


      {isProfileOk && <><ActionRequiredValidationModal show={showActionReqPopup} />
        <VendorBlockedStausModal show={showVendorBlockedPopup} /></>}
    </div>
  );
}

export default Header;